module.exports = __webpack_public_path__ + "img/375.2472f2cb.jpg";